"use strict";

var $ = require("jquery");
import { addToCart } from './_addToCart.js';
import { dropdownClose } from './_dropdownClose.js';
import { productGallery } from './_productGallery.js';
import { Fancybox } from "@fancyapps/ui";

$(document).ready(function () {

    $('button.quickview').on('click', function (e) {
        e.preventDefault();

        var id = $(this).attr('data-id');

        // Ajax action.
        $.ajax({
            type: 'post',
            url: vars.ajaxurl,
            data: {
                action: 'juist_quickview',
                id: id
            },
            beforeSend: function () {
                // loadingEl.show();
            },
            success: function (response) {
                if (response) {
                    Fancybox.show(
                        [
                            {
                                src: '<div class="modal-quickview">' + response + '</div>',
                                type: "html",
                            }
                        ],
                        {
                            mainClass: 'modal-quickview',
                            on: {
                                "closing": () => {
                                    dropdownClose();
                                }
                            }
                        }
                    );

                    productGallery();

                    $('form.cart').on('submit', function (e) {
                        e.preventDefault();
                        addToCart($(this), 'quickview');
                    });
                }
            }
        });
    });
});
